import Marketplace from '@spike/marketplace-model';
import MasterData from '@spike/masterdata-model';
import { formatTime } from 'components/Marketplace/BusinessSettings/Feeding/Feeding';

export type FeedingSlotMoment = 'morning' | 'afternoon' | 'evening';
export type FeedingSlotTimes = Record<FeedingSlotMoment, string>;

const DEFAULT_FEEDING_TIMES: FeedingSlotTimes = {
    morning: '08:00',
    afternoon: '13:00',
    evening: '17:00'
};

const toTitleCase = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

const getMasterDataMomentTime = (masterData: MasterData, moment: FeedingSlotMoment): string | undefined => {
    const name = toTitleCase(moment);

    if (moment === 'afternoon') {
        return (
            masterData.feedingMomentTypes.find(m => m.name === 'Afternoon')?.time ||
            masterData.feedingMomentTypes.find(m => m.name === 'Aftenoon')?.time
        );
    }

    return masterData.feedingMomentTypes.find(m => m.name === name)?.time;
};

const getNotificationMomentTime = (marketplace: Marketplace, moment: FeedingSlotMoment): string | undefined =>
    marketplace.settings.find(s => s.key === `${moment}_feeding_time`)?.value;

export const getFeedingSlotTimes = (
    marketplace: Marketplace,
    masterData: MasterData,
    opts?: { fallbackToDefaults?: boolean }
): FeedingSlotTimes => {
    const getTime = (moment: FeedingSlotMoment): string => {
        const raw =
            getNotificationMomentTime(marketplace, moment) ||
            getMasterDataMomentTime(masterData, moment) ||
            (opts?.fallbackToDefaults ? DEFAULT_FEEDING_TIMES[moment] : '');
        return formatTime(raw);
    };

    return {
        morning: getTime('morning'),
        afternoon: getTime('afternoon'),
        evening: getTime('evening')
    };
};
